import { mapReducer } from "./map.reducer";
import { rentReducer } from "./rent.reducer";

const reducers = ({ map, rent }, action) => ({
    map: mapReducer(map, action),
    rent: rentReducer(rent, action)
});

export default reducers;
